webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(7)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(15),
  /* template */
  __webpack_require__(5),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(8)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(16),
  /* template */
  __webpack_require__(6),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-46dd337e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('upload', {
    attrs: {
      "action": _vm.action,
      "token": _vm.token,
      "multiple": _vm.multiple,
      "accept": _vm.accept
    },
    on: {
      "on-upload": _vm.uploadFile,
      "on-error": _vm.uploadErr,
      "on-progress": _vm.progress
    }
  }, [_c('template', {
    slot: "form"
  }), _vm._v(" "), _c('template', {
    slot: "picker"
  }, [_c('span', {
    staticClass: "btn"
  }, [_vm._v("上传图片")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h2', [_vm._v("上传结果")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "result"
    }
  }, [_c('p', [_vm._v("hash: " + _vm._s(_vm.hashes))]), _vm._v(" "), _c('p', [_vm._v("key: " + _vm._s(_vm.keys))])]), _vm._v(" "), _c('div', _vm._l((_vm.hashes), function(item) {
    return _c('img', {
      key: item,
      staticClass: "viewimg",
      attrs: {
        "src": item,
        "alt": "hashes"
      }
    })
  })), _vm._v(" "), _c('div', _vm._l((_vm.keys), function(item) {
    return _c('img', {
      key: item,
      staticClass: "viewimg",
      attrs: {
        "src": item,
        "alt": "keys"
      }
    })
  }))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploadMsg.length),
      expression: "uploadMsg.length"
    }],
    staticClass: "block",
    attrs: {
      "id": "ajaxErr"
    }
  }, [_c('h4', [_vm._v("uploadMsg: ")]), _vm._v(" "), _vm._l((_vm.uploadMsg), function(item, index) {
    return _c('p', {
      key: index
    }, [_vm._v(_vm._s(item))])
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    attrs: {
      "id": _vm.formId,
      "method": _vm.method,
      "enctype": "multipart/form-data"
    }
  }, [_c('input', {
    attrs: {
      "name": "token",
      "type": "hidden"
    },
    domProps: {
      "value": _vm.token
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "name": "file",
      "id": _vm.pickerId,
      "type": "file",
      "accept": _vm.accept,
      "multiple": _vm.multiple
    },
    on: {
      "change": _vm.upload
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "name": "accept",
      "type": "hidden"
    }
  }), _vm._v(" "), _vm._t("form")], 2), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.pickerId
    }
  }, [_vm._t("picker", [_c('em', [_vm._v("upload")])])], 2)])
},staticRenderFns: []}

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(1);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    template: '<App/>',
    components: {
        App: __WEBPACK_IMPORTED_MODULE_1__App___default.a
    }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_upload_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_upload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_upload_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    components: {
        upload: __WEBPACK_IMPORTED_MODULE_1__components_upload_vue___default.a
    },
    data: function data() {
        return {
            action: 'http://upload.qiniu.com/', // 替换自己的上传链接
            accept: 'image/png, image/jpeg, image/gif',
            multiple: true,
            token: 'QWYn5TFQsLLU1pL5MFEmX3s5DmHdUThav9WyOWOm:ZIpAGEJRtGVzfLjqDTjJwF4FbeY=:eyJkZWxldGVBZnRlckRheXMiOjcsInNjb3BlIjoianNzZGsiLCJkZWFkbGluZSI6MTUwNDQ0NDk1MH0=', // 从[http://jssdk.demo.qiniu.io/formdata]获取
            hashes: [],
            keys: [],
            uploadMsg: []
        };
    },
    methods: {
        uploadFile: function uploadFile(res) {
            this.hashes.push('http://7j1xky.com2.z0.glb.qiniucdn.com/' + res.hash);
            this.keys.push('http://7j1xky.com2.z0.glb.qiniucdn.com/' + res.key);
        },
        uploadErr: function uploadErr(res) {
            this.uploadMsg.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res));
        },
        progress: function progress(e) {
            this.uploadMsg.push('e.loaded: ' + e.loaded + ', e.total: ' + e.total + ', percent: ' + e.loaded / e.total * 100);
        }
    }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        method: {
            type: String,
            default: 'post'
        },
        action: {
            type: String,
            default: ''
        },
        token: {
            type: String,
            default: ''
        },
        accept: {
            type: String,
            default: 'image/png, image/jpeg, image/gif'
        },
        multiple: {
            type: Boolean,
            default: false
        },
        callback: {
            type: Function,
            default: function _default() {
                // console.log('upload done');
            }
        }
    },
    data: function data() {
        return {
            key: '',
            formId: 'upload' + new Date().getTime(),
            pickerId: 'picker' + new Date().getTime()
        };
    },
    methods: {
        upload: function upload() {
            var _this = this;

            this.$nextTick(function () {
                var formData = new FormData(document.getElementById(_this.formId));
                if (_this.multiple) {
                    var i = 0;
                    var files = formData.getAll('file');
                    var length = files.length;
                    for (; i < length; i++) {
                        formData.set('file', files[i]);
                        _this.$http.post(_this.action, formData).then(function (res) {
                            _this.$emit('on-upload', res.body);
                        });
                    }
                } else {
                    _this.$http.post(_this.action, formData).then(function (res) {
                        _this.$emit('on-upload', res.body);
                    });
                }
            });
        }
    }
});

/***/ }),
/* 17 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[14]);


// WEBPACK FOOTER //
// static/js/app.513b742b2e2ed588ab15.js